@if (loading()) {
  <div class="eventq-attachment-card eventq-attachment-card--loading" aria-hidden="true">
    <div class="eventq-attachment-card__skeleton">
      <span class="eventq-attachment-card__skeleton-icon"></span>
      <span class="eventq-attachment-card__skeleton-line eventq-attachment-card__skeleton-line--category"></span>
      <span class="eventq-attachment-card__skeleton-line eventq-attachment-card__skeleton-line--name"></span>
      <span class="eventq-attachment-card__skeleton-line eventq-attachment-card__skeleton-line--meta"></span>
    </div>
  </div>
} @else {
  <button
    type="button"
    class="eventq-attachment-card"
    (click)="onActivate()"
  >
    <div class="eventq-attachment-card__icon" aria-hidden="true">
      <img
        class="eventq-attachment-card__icon-img"
        [src]="fileIconSrc() | prefixUrl"
        alt=""
        width="60"
        height="80"
      />
      @if (fileType()) {
        <span class="eventq-attachment-card__file-type">{{ fileType() }}</span>
      }
    </div>
    <div class="eventq-attachment-card__text">
      @if (category()) {
        <p class="eventq-attachment-card__category">{{ category() }}</p>
      }
      <p class="eventq-attachment-card__file-name">{{ fileName() }}</p>
    </div>
    @if (expirationDate()) {
      <p class="eventq-attachment-card__expiration">
        Expiration Date: {{ expirationDate() }}
      </p>
    }
  </button>

  <div class="eventq-attachment-card__actions" aria-label="Attachment actions">
    <button
      type="button"
      class="eventq-attachment-card__action"
      aria-label="Preview"
      (click)="onPreview($event)"
    >
      <mat-icon aria-hidden="true">remove_red_eye</mat-icon>
    </button>
    @if (downloadHref()) {
      <a
        class="eventq-attachment-card__action"
        aria-label="Download"
        [href]="downloadHref()"
        [attr.download]="downloadFileName()"
        (click)="onDownloadActivate($event)"
      >
        <mat-icon aria-hidden="true">file_download</mat-icon>
      </a>
    } @else {
      <button
        type="button"
        class="eventq-attachment-card__action"
        aria-label="Download"
        (click)="onDownloadActivate($event)"
      >
        <mat-icon aria-hidden="true">file_download</mat-icon>
      </button>
    }
  </div>
}
